export enum DashboardStateKey {
  ORIGIN_URL_PARAM = 'origin', // This is required to enable message posting from the iframe to the host which have different domains
  SESSION_TOKEN_COOKIE = 'session_token',
}
